import React from "react";
import { Link } from "react-router-dom";
import { XCircle, ArrowLeft, RefreshCw } from "lucide-react";
import { Button } from "../components/ui/button";

export default function CheckoutCancel() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-[#f5f7ff] via-white to-[#eef2ff] flex items-center justify-center p-4">
      <div className="bg-white rounded-3xl shadow-2xl max-w-md w-full p-8 border border-slate-200 text-center" data-testid="checkout-cancel">
        <div className="mx-auto h-20 w-20 rounded-full bg-slate-100 text-slate-500 flex items-center justify-center mb-5">
          <XCircle className="h-10 w-10" />
        </div>
        <h1 className="text-2xl font-extrabold text-[#0a1f55]">Pagamento annullato</h1>
        <p className="mt-2 text-[14px] text-slate-600">
          Hai annullato il pagamento. Nessun importo è stato addebitato. Puoi riprovare in qualsiasi momento.
        </p>
        <div className="mt-7 flex gap-2 justify-center">
          <Button variant="outline" asChild>
            <Link to="/" data-testid="cancel-home"><ArrowLeft className="mr-2 h-4 w-4" /> Torna alla home</Link>
          </Button>
          <Button asChild className="bg-[#102a6b] hover:bg-[#0a1f55] text-white font-bold">
            <Link to="/#pacchetti" data-testid="cancel-retry"><RefreshCw className="mr-2 h-4 w-4" /> Riprova</Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
